export default __webpack_public_path__ + "static/media/medalha-ouro.27b0f56f.svg";